import {Location} from '@angular/common';

export class LocationUtils {

  private static BASE_URI: string = null;

  /**
   *  document.baseURI workaround of IE
   */
  static getBaseURI(): string {
    try {
      if (!LocationUtils.BASE_URI) {
        LocationUtils.BASE_URI = Location.stripTrailingSlash(document.baseURI ? document.baseURI : document.getElementsByTagName('base')[0]['href']);
      }
      return LocationUtils.BASE_URI;
    } catch (e) {
      return null;
    }
  }

  /**
   *  window.location.assign() with base url;
   *  @param url normalized relative url started with '/'
   */
  static assign(url: string) {
    window.location['assign'](Location.joinWithSlash(LocationUtils.getBaseURI(), url));
  }

  /**
   *  window.location.replace() with base url;
   *  @param url normalized relative url started with '/'
   */
  static replace(url: string) {
    window.location['replace'](Location.joinWithSlash(LocationUtils.getBaseURI(), url));
  }

  // private static replaceEndSlash(str: string): string {
  //   return str.replace(/\/+$/, '');
  // }

}
